import MCSCSplashPage from './MCSCSplashPage';

export { MCSCSplashPage };
export default MCSCSplashPage;
